(() => {
  'use strict';
  const script = document.currentScript;
  const route = new URL(script.dataset.searchUrl, location.origin);
  const cache = new Map();
  let navigationVersion = 0;
  const candidate = (value) => /^[a-z0-9][a-z0-9._/-]{2,63}$/i.test(value) && /\d/.test(value);
  const skuQuery = (value) => 'variants.sku:"' + value + '"';

  async function isExactSku(value) {
    const key = value.toLowerCase();
    if (cache.has(key)) return cache.get(key);
    const pending = (async () => {
      const url = new URL(route);
      url.searchParams.set('q', skuQuery(value));
      url.searchParams.set('type', 'product');
      url.searchParams.set('view', 'wm-sku-lookup');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 3000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) return false;
        const data = await response.json();
        return Array.isArray(data.skus) && data.skus.some((skus) =>
          Array.isArray(skus) && skus.some((sku) => typeof sku === 'string' && sku.toLowerCase() === key)
        );
      } catch {
        return false;
      } finally {
        clearTimeout(timeout);
      }
    })();
    cache.set(key, pending);
    return pending;
  }

  function preservePreview(url) {
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'get') return;
    const action = new URL(form.action, location.href);
    if (action.origin !== route.origin || action.pathname !== route.pathname) return;
    const input = form.querySelector('input[name="q"]:not([type="hidden"])');
    const value = input?.value.trim();
    if (!value || !candidate(value)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const version = ++navigationVersion;
    const originalBusy = form.getAttribute('aria-busy');
    form.setAttribute('aria-busy', 'true');
    const exact = await isExactSku(value);
    if (originalBusy === null) form.removeAttribute('aria-busy');
    else form.setAttribute('aria-busy', originalBusy);
    if (version !== navigationVersion || input.value.trim() !== value) return;
    const url = new URL(action);
    url.search = new URLSearchParams(new FormData(form)).toString();
    if (exact) {
      url.searchParams.set('q', skuQuery(value));
      url.searchParams.set('type', 'product');
      url.searchParams.delete('page');
    }
    location.assign(preservePreview(url).href);
  }, true);

  document.addEventListener('input', (event) => {
    if (event.target.matches?.('input[name="q"]')) navigationVersion++;
  }, true);

  const current = new URL(location.href);
  const value = current.searchParams.get('q')?.trim();
  if (current.pathname === route.pathname && !current.searchParams.has('view') &&
      !current.searchParams.has('section_id') && !current.searchParams.has('sections') &&
      value && candidate(value)) {
    const version = navigationVersion;
    isExactSku(value).then((exact) => {
      if (!exact || version !== navigationVersion) return;
      current.searchParams.set('q', skuQuery(value));
      current.searchParams.set('type', 'product');
      current.searchParams.delete('page');
      location.replace(current.href);
    });
  }
})();
